import { RouteComponentProps, withRouter } from 'react-router';
import React from 'react';

import { HeadWrapper } from '../../elements';
import invalid from "./Invalid.module.scss";
import { Link } from 'react-router-dom';
import Routes from '../../components/Routes';
import { ReactComponent as LoginLogoIcon } from '../../styles/images/logo-login.svg';
import strings from '../../lang/lang';

type PropsType = RouteComponentProps<any>;

class InvalidPage extends React.Component<PropsType, any> {
  render() {
    return (
      <>
        <HeadWrapper
          href="https://developer.staq.io/invalidPage"
        />
        <div className={invalid.invalid}>
          <Link to={Routes.routes.ROOT.path} className={invalid.invalid__logo}>
            <LoginLogoIcon />
          </Link>
          <p>{strings.invalidPage.text.description}</p>
        </div>
      </>
    );
  }
}

export default withRouter(InvalidPage);
